import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, UrlSerializer } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploaderCustom } from './SharedComponents/FileUploader';
import { SortJsonData } from './Pipes/SortingPipe';
import { FilterJsonData } from './Pipes/FilterPipe';
import { DefaultTS } from './SharedComponents/Default';
import { Messaging } from './Communication/Messaging';
import { RoutingState } from './SharedComponents/RoutingState';
import { LowerCaseUrlSerializer } from './SharedComponents/URLSerializer';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptorService } from './Interceptors/token-interceptor.service';
import { PTDragDropUpload } from './PTDragDropUpload/PTDragDropUpload';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

  ],
  declarations: [
    FileUploaderCustom,
    SortJsonData,
    DefaultTS,
    Messaging,
    PTDragDropUpload
    //RoutingState,
    //DatePipe

  ],
  exports: [
    RouterModule,
    FileUploaderCustom,
    SortJsonData,
    DefaultTS,
    Messaging,
    PTDragDropUpload,
    //RoutingState,
    //DatePipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
})


export class SharedDataModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedDataModule,
      providers: [FileUploaderCustom, SortJsonData, FilterJsonData, DefaultTS, Messaging, RoutingState, DatePipe,
        {
          provide: UrlSerializer,
          useClass: LowerCaseUrlSerializer
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptorService,
          multi: true,
        },
      ]
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/SharedData.module.ts